import { useEffect, useState } from 'react'

/** Read the query synchronously, so the first paint is already correct. */
const currentMatch = (query: string): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches

export function useMediaQuery(query: string): boolean {
  // Seeded from the real match rather than `false`. Every consumer that renders *different
  // markup* per breakpoint — the sign-in page picks between the featured hero panel and the
  // phone rail — would otherwise paint the small-screen branch for a frame and then swap it.
  const [matches, setMatches] = useState<boolean>(() => currentMatch(query))

  useEffect(() => {
    const media = window.matchMedia(query)
    setMatches(media.matches)

    const listener = (): void => setMatches(media.matches)
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [query])

  return matches
}
